import { useCallback, useEffect, useRef, useState } from 'react';

export function useDebouncedValue<T>(
  value: T,
  delay?: number
): { debouncedValue: T; forceUpdate: (newVal: T) => void } {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timerRef.current = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timerRef?.current);
    };
  }, [value, delay]);

  const forceUpdate = useCallback((newVal: T) => {
    clearTimeout(timerRef?.current);
    setDebouncedValue(newVal);
  }, []);

  return { debouncedValue, forceUpdate };
}
